import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent, { MenuContentProps } from './MenuContent';
import CardAlert from './CardAlert';
import OptionsMenu from './OptionsMenu';
import { LogoMarca } from '../../core/components/logo';
import { AccountCircle, CastConnected, ConnectingAirports, LeakAdd, LeakRemove, Logout, Person, Refresh } from '@mui/icons-material';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { useAuth } from '../../core/modulos/logIn/view';


const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu(props: MenuContentProps) {
  const auth = useAuth();
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
          justifyContent: "center",
          flexDirection: "column"
        }}
      >
        <LogoMarca />
        <Stack flexDirection={"row"} justifyContent={"space-around"} alignItems={"center"} >
          <Typography variant='caption' alignSelf={"center"}>Gestão e vendas de gás {auth.version}</Typography>
          <Tooltip title={`Sistema ${props.statusConnection==="on"?"Online":"OffLine"}`}>
          {props.statusConnection === "on"?(
            <LeakAdd fontSize='medium' color='success' />
          ):(
            <LeakRemove fontSize='medium' color='error' />
          )}
          </Tooltip>
        </Stack>
        <Typography variant='caption' color='info' alignSelf={"center"}>Dados {props.dbConnected}</Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent {...props} />

      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          alt="User"
          sx={{ width: 36, height: 36 }}
        >
          <Person fontSize='large' />
        </Avatar>
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {props.funcLogado.nome}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Operador
          </Typography>
        </Box>
        <IconButton onClick={props.logout}>
          <Logout />
        </IconButton>


        {/* <OptionsMenu /> */}
      </Stack>
    </Drawer>
  );
}
